import { transformMc, transformSc } from "../Inputs/Choice";
import { transformSf } from "../Inputs/Choose";
import { transformFt } from "../Inputs/Freetext";
import { transformIf } from "../Inputs/InputField";
import { transformLabeling } from "../Inputs/Labeling";
import { transformOrdering } from "../Inputs/Ordering";
import { inputTransformation } from "./Interface";


export function transformInput(data:Object, ind:number, object:HTMLElement):inputTransformation{
    let result = {}
    switch(data.type){
        case "if":
            result = transformIf(data, ind);
            break;
        case "mc":
            result = transformMc(data, ind, object);
            break;
        case "sc":
            result = transformSc(data, ind, object);
            break;
        case "sf": 
            result = transformSf(data, ind);
            break;
        case "ft":
            result = transformFt(data, ind, object);
            break;
        case "la":
            result = transformLabeling(data, ind);
            break;
        case "dr":
            result = transformLabeling(data, ind);
            break;
        case "or":
            result = transformOrdering(data, ind);
            break;
    }

    return {
        solution: result.solution,
        html: result.html,
    }
}
